import { applicationPaths, headerItems, rbacPermissionGroups } from "./constants";
import { ownerStatuses, cisoStatuses } from "./enums";

const Helper = (() => {
    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + "  " + date.getHours() + ":" + date.getMinutes();
    }

    const leadingZero = (num) => `0${num}`.slice(-2);

    const formatTime = (date) =>
        [date.getHours(), date.getMinutes()]
            .map(leadingZero)
            .join(':');

    const parseDate = (dateString) => {
        if (dateString == "0001-01-01T00:00:00" || dateString == "0001-01-01T00:00:00.000Z") {
            return "N/A";
        }
        const date = new Date(dateString);
        return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + "  " + formatTime(date);
    }

    const pgDependencyGraphClickHandler = (id, pgName) => {
        localStorage.setItem("pgID", id);
        localStorage.setItem("pgName", pgName);
        window.open(`${window.location.origin}/dependency-graph`, "_blank", "width=900,height=800");
    };

    const isCurrentUserCiso = (currentUser) => currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpCiso)) !== undefined ? true : false;

    const isCurrentUserReportsUser = (currentUser) => currentUser.memberOf.find(x => x.includes(rbacPermissionGroups.mpReports)) !== undefined ? true : false;

    const buildBaseGetRolesByStatusDto = (id, currentUser) => {
        return {
            employeeId: id,
            isCiso: Helper.isCurrentUserCiso(currentUser)
        }
    };

    const buildGetRolesByStatusDto = (status, id, currentUser) => {
        return {
            status: status,
            employeeId: id,
            isCiso: Helper.isCurrentUserCiso(currentUser)
        }
    };

    const getCisoStatus = (selectedAdditionalApprovers, defaultImportant) => {
        if (selectedAdditionalApprovers.length > 0 && defaultImportant.value) {
            return cisoStatuses.cisoApprovedAdditionalApprovalsImportant;
        }
        else if (selectedAdditionalApprovers.length > 0) {
            return cisoStatuses.cisoApprovedAdditionalApprovals;
        }
        else if (defaultImportant.value) {
            return cisoStatuses.cisoApprovedImportant;
        }
        else return cisoStatuses.cisoApproved;
    };

    const getOwnerStatus = (selectedAdditionalApprovers) => {
        if (selectedAdditionalApprovers.length > 0) {
            return ownerStatuses.ownerApprovedAdditionalApprovals
        }
        else {
            return ownerStatuses.ownerApproved;
        }
    };

    const getActiveHeaderItem = () => {
        switch (window.location.pathname) {
            case applicationPaths.createRole:
            case applicationPaths.pendingRoles:
            case applicationPaths.pendingPgApprovalRoles:
            case applicationPaths.approvedRoles:
            case applicationPaths.pendingAdditionalApprovalRoles:
            case applicationPaths.assignedImportantRoles:
            case applicationPaths.productionRoles:
                return headerItems.roleLifecycle;
            case applicationPaths.rolesAdminPanel:
                return headerItems.rolesAdminPanel;
            case applicationPaths.qaReview:
                return headerItems.qaReview;
            case applicationPaths.soxSystems:
                return headerItems.soxSystems;
            case applicationPaths.licenseAdminPath:
                return headerItems.licenseAdmin;
            case applicationPaths.licenseFormsPath:
                return headerItems.licenseForms;
            default:
                return headerItems.reporting;
        }
    };

    const skip = (array, positions) => {
        let arr = [];

        for (var i = positions; i < array.length; i += 1) {
            arr.push(array[i]);
        }

        return arr;
    };

    return {
        formatDateTime,
        parseDate,
        pgDependencyGraphClickHandler,
        isCurrentUserCiso,
        isCurrentUserReportsUser,
        buildBaseGetRolesByStatusDto,
        buildGetRolesByStatusDto,
        getCisoStatus,
        getOwnerStatus,
        getActiveHeaderItem,
        skip
    }
})();

export default Helper;